import dao from '../../../../dao/subsDao';

const QUERY_CREDIT_CARD =
  'pages/generalsettings/billing/information/QUERY_CREDIT_CARD';
const QUERY_CREDIT_CARD_SUCCESS =
  'pages/generalsettings/billing/information/QUERY_CREDIT_CARD_SUCCESS';

const initialState = {
  creditCard: {},
  subscriptionItem: {},
  isLoaded: false,
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case QUERY_CREDIT_CARD:
      return {
        ...state,
        isLoaded: false,
      };
    case QUERY_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        creditCard: action.json,
      };
    default:
      return state;
  }
};

export function queryCreditCard() {
  return dispatch => {
    dispatch({
      type: QUERY_CREDIT_CARD,
    });
    return dao
      .queryCreditCard()
      .then(json => dispatch(queryCreditCardSuccess(json)));
  };
}

function queryCreditCardSuccess(json) {
  return {
    type: QUERY_CREDIT_CARD_SUCCESS,
    json,
  };
}
